import React from 'react';

/* Common */
import { Icon } from '~/components/common';

/* Components */
import FavoritesRemoveButton from '~/components/favorites-toggle/components/FavoritesRemoveButton';

/* Icons */
import carIcon from '~/../symbols/car.svg';

/* Utilities */
import { trans } from '~/utilities';

export default function CardVehicleUnavailable({
    id,
    title,
    subtitle,
    onFavoriteRemoved,
    removeFavoriteUrl,
}) {
    return (
        <div className="card card--product card--unavailable text--sm">
            <div className="card__header card__placeholder">
                <FavoritesRemoveButton
                    vehicleId={id}
                    onFavoriteRemoved={onFavoriteRemoved}
                    removeFavoriteUrl={removeFavoriteUrl}
                />

                <Icon url={carIcon} className="card__placeholder-icon" />

                <span className="badge badge--unavailable">
                    {trans('app.favorites.unavailable.badge')}
                </span>
            </div>

            <div className="card-body d-flex flex-column">
                {title ? (
                    <p className="title h6 mb-0">{title}</p>
                ) : null}
                {subtitle ? (
                    <p className="text--12 text--md-14 mb-0 text-truncate">{subtitle}</p>
                ) : null}
                <p className="text--12 text--md-14 text-muted--60 mt-2 mb-0">
                    {trans('app.favorites.unavailable.text')}
                </p>
            </div>
        </div>
    );
}
